import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getModelThumbnail } from '../../../bundles/sites';
import { Label } from '@iq/react-components';
import './SiteImagePreviewField.scss';

const SiteImagePreviewField = (properties) => {
  const {
    formContext: { model, version, selectedModel, name },
  } = properties;
  const forgeThumbnail = useSelector((state) => getModelThumbnail(state, model, version));

  const hasCustomThumbnail =
    selectedModel?.versions[0]?.thumbnail?.split(':')[1]?.split('/')[0] === 'image';
  const hasForgeThumbnail = forgeThumbnail?.split(':')[1]?.split('/')[0] === 'image';
  const displayThumbnail =
    (hasCustomThumbnail && selectedModel?.versions[0]?.thumbnail) ||
    (hasForgeThumbnail && forgeThumbnail);

  return (
    <div className="site-model-page">
      <div className="model-info-label">
        <Label>Site Image Preview</Label>
      </div>
      <div className="model-version-thumbnail">
        {hasCustomThumbnail || hasForgeThumbnail ? (
          <img
            src={displayThumbnail}
            alt={`Thumbnail for ${selectedModel?.name} - v${selectedModel?.versions[0]?.versionNumber}`}
          />
        ) : (
          <div className="model-site-thumbnail-component">
            <div className="model-thumbnail-placeholder">{name && name[0]}</div>
          </div>
        )}
      </div>
    </div>
  );
};

SiteImagePreviewField.propTypes = {
  formContext: PropTypes.shape({
    model: PropTypes.any,
    version: PropTypes.any,
    selectedModel: PropTypes.shape({
      name: PropTypes.string,
      versions: PropTypes.arrayOf(
        PropTypes.shape({
          versionNumber: PropTypes.any,
          thumbnail: PropTypes.string,
        })
      ),
    }),
    name: PropTypes.string,
  }).isRequired,
};

export default SiteImagePreviewField;
